import { __decorate } from "tslib";
import { AutoEncoder, StringDecoder, field, IntegerDecoder, ArrayDecoder } from '@simonbackx/simple-encoding';
import { upgradePriceFrom2To4DecimalPlaces } from '../upgradePriceFrom2To4DecimalPlaces.js';
export class UitpasPriceCheckRequest extends AutoEncoder {
}
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], UitpasPriceCheckRequest.prototype, "basePrice", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true }),
    field({ ...upgradePriceFrom2To4DecimalPlaces, nullable: true })
], UitpasPriceCheckRequest.prototype, "reducedPrice", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], UitpasPriceCheckRequest.prototype, "uitpasEventUrl", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), nullable: true })
], UitpasPriceCheckRequest.prototype, "uitpasNumbers", void 0);
export class UitpasPriceCheckResponse extends AutoEncoder {
}
__decorate([
    field({ decoder: new ArrayDecoder(IntegerDecoder) })
], UitpasPriceCheckResponse.prototype, "prices", void 0);
//# sourceMappingURL=UitpasPriceCheckRequest.js.map